module.exports = __webpack_public_path__ + "img/assign.f0466dfd.png";